import { MuiThemeProvider } from "@material-ui/core/styles";
import { createBrowserHistory } from "history";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { Store } from "redux";
import { PersistGate } from "redux-persist/integration/react";

import { AppConnected } from "./components/App/App";
import registerServiceWorker from "./registerServiceWorker";
import { services } from "./services";
import { buildPersistor, buildStore } from "./store";
import { theme } from "./theme/theme";
import { RootState } from "./types/RootState";

const history = createBrowserHistory();
const store: Store<RootState> = buildStore(history);

services.init(store).then(() => {
    ReactDOM.render(
        <div>
            <MuiThemeProvider theme={theme}>
                <Provider store={store}>
                    <PersistGate persistor={buildPersistor(store)}>
                        <AppConnected history={history} />
                    </PersistGate>
                </Provider>
            </MuiThemeProvider>
        </div>,
        document.getElementById("root") as HTMLElement
    );
});

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx